import {createActorContext} from '@xstate/react';
import React from 'react';
import {Edge, Node} from 'reactflow';

import {LayoutSettings} from 'ui-library/reactflow/layout/calculateDimensionsForLayout';

import {EntityMap_entityMap_EntityMapNode_entities as EntityMapEntityNodeOrInaccessibleInfoNode} from './__generated/EntityMap';
import {EntityMapMachine} from './EntityMapMachine';

// Create the actor context for the EntityMapMachine
export const EntityMapMachineContext = createActorContext(EntityMapMachine);
export const useEntityMapActorRef = EntityMapMachineContext.useActorRef;
export const useEntityMapSelector = EntityMapMachineContext.useSelector;

// Provider component to wrap the subtree
export const EntityMapMachineProvider = ({
  entityId,
  layoutSettings,
  children,
}: {
  entityId: string;
  layoutSettings: Partial<LayoutSettings<Node<EntityMapEntityNodeOrInaccessibleInfoNode>, Edge>>;
  children: React.ReactNode;
}): JSX.Element => (
  <EntityMapMachineContext.Provider options={{input: {entityId, layoutSettings}}}>
    {children}
  </EntityMapMachineContext.Provider>
);
